// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Signin_wrap__1FKOm","linkItem":"Signin_linkItem__3eKdj","link":"Signin_link__2eaP9","rightBlock":"Signin_rightBlock__1RgSk","rightBlockWrap":"Signin_rightBlockWrap__3gmm_"};